<template>
  <td class="list_star" rowspan="3" :style="{ width: `${width}px` }">
    <span class="edit_cell" @click.stop="onClickListStar()">
      {{ formatText(_star) }}
    </span>
  </td>
</template>

<script>
import Common from '@/mixins/common'
import BukkenRepository from '@/repositories/bukkenRepository'
import ListStar from '@/constants/list_star.js'
export default {
  mixins: [Common],
  props: {
    id: {
      type: Number,
      default: null,
    },
    star: {
      type: String,
      default: '',
    },
    updatedAt: {
      type: String,
      default: '',
    },
    width: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      ListStar: ListStar,
    }
  },
  computed: {
    _star: {
      get() {
        return this.star
      },
      set(val) {
        this.$emit('update:star', val)
      },
    },
    _updatedAt: {
      get() {
        return this.updatedAt
      },
      set(val) {
        this.$emit('update:updatedAt', val)
      },
    },
  },
  methods: {
    // ★ クリック処理
    async onClickListStar() {
      const ListStar = this.ListStar
      const currentStar = this._star
      const ListStarIdx = _.findIndex(ListStar, function(o) {
        return o === currentStar
      })
      const star = ListStar.length > ListStarIdx + 1 ? ListStar[ListStarIdx + 1] : ListStar[0]
      await BukkenRepository.putListStar(this.id, star)
        .then(res => {
          if (res.result) {
            // データ更新処理
            let data = res.data
            this._star = data.list_star
            this._updatedAt = this.dateFormat(data.updated_at)
          } else {
            alert(res.message)
          }
        })
        .catch(() => {
          alert('データ更新に失敗しました。')
        })
        .finally(() => {})
    },
    dateFormat(_timestamp) {
      if (!_timestamp) return '-'
      var _d = new Date(_timestamp * 1000)

      var Y = _d.getFullYear()
      var m = ('0' + (_d.getMonth() + 1)).slice(-2)
      var d = ('0' + _d.getDate()).slice(-2)

      return `${Y}/${m}/${d}`
    },
  },
}
</script>

<style lang="scss" scoped>
.list_star {
  .edit_cell {
    width: 100%;
    display: inline-block;
    transition: ease 0.3s;
    cursor: pointer;

    &:hover {
      transition: ease 0.3s;
      background-color: #ffe6c0;
    }
  }
}
</style>
